module.exports = __webpack_public_path__ + "img/banner_top.c5431221.jpg";